//
// Represents a rule in a password policy.
export abstract class PasswordRule {
  // User-facing description of the rule.
  public description: string;

  // Indicates if valid passwords MUST (true) or MUST NOT (false) meet the rule.
  public isPositiveRule = true;

  // Evaluates password according to the configured rule and returns if it is valid.
  public abstract apply(password: string): boolean;
}

//
// Implements a regex-based rule as per the password API.
export class PatternRule extends PasswordRule {
  private privatePattern: string;
  public set pattern(value: string) {
    this.privatePattern = value;
    this.regex = new RegExp(value);
  }
  public get pattern(): string {
    return this.privatePattern;
  }

  private regex: RegExp;

  public override apply(password: string): boolean {
    return this.regex.test(password) == this.isPositiveRule;
  }

  // This method is used to create real instances from source service data
  public hydrateFrom(source: PatternRule) {
    this.description = source.description;
    this.isPositiveRule = source.isPositiveRule;
    this.pattern = source.pattern;
  }
}

//
// Implements a rule to facilitate reqiring the user to re-enter their password as if it were just
// part of the policy.
export class PasswordsMatchRule extends PasswordRule {
  // holds the "retyped" value
  public toMatch: string;

  constructor() {
    super();
    this.description = 'Password fields must match';
  }

  public override apply(password: string): boolean {
    return (password === this.toMatch) == this.isPositiveRule;
  }
}